<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/beyond-ec/feature/summary.jpg'"
        :altText="`新・呼び出しシステムBeyond EC（ビヨンド イーシー）`"
        :headerText="
          `スマホがそのままレシーバーに !
          Wi-Fi 利用で呼び出しシステムは進化する。`
        "
        :detailText="
          `Beyond EC は、通信無料の特定小電力無線（920MHz 帯）と、Wi-Fi（無線 LAN）を組み合わせた呼び出しシステム。
          Wi-Fi を使うので専用のレシーバーは不要。お手持ちの Android スマホをそのまま表示機として利用できます。`
        "
        :color="'blue'"
      />

      <img
        class="feature-image"
        v-lazy="'/static/products/beyond-ec/feature/feature_01.png'"
      />

      <div class="feature-title">
        表示機（Androidスマホ）
      </div>

      <div
        class="feature-contents"
        style="display: flex; flex-wrap: wrap; justify-content: space-between;"
      >
        <div class="feature-content" style="margin-top: 0; width: 100%;">
          <content-header
            title="お手持ちのスマホがそのままレシーバーに"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            専用アプリをダウンロードすれば、スマホがそのままレシーバーに。操作は簡単、スワイプ／フリック／タップなど、スマホと同じく直感的に。
          </p>
          <p>
            着信音やバイブレーション設定なども多彩なメニューから選べます。
          </p>
        </div>
        <div class="feature-content vertical-content">
          <content-header
            title="「呼出中」をタップし情報を確認"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <div>
            <p>
              着信があれば「呼出中」をタップ。
            </p>
            <p>
              呼出元、呼出対象グループ、経過時間が順番に表示されます。
            </p>
          </div>
          <div
            style="margin-top: 20px; display: flex; justify-content: space-around;"
          >
            <img
              v-lazy="'/static/products/beyond-ec/feature/feature_02.png'"
              style="position: static; width: 40%; height: 100%;"
              :style="this.$isPC ? '' : 'width: 35%'"
            />
            <div style="width: 50%; display: grid" v-if="this.$isPC">
              <p style="line-height: 16px; margin-top: 30px;">
                スマホと呼出機を自由にひもづけ。<br />
                指定した呼出機の情報だけを<br />
                表示できます。<br />
                ※下記「グループ割当て機能」を参照
              </p>
              <p style="line-height: 16px; margin-top: 100px;">
                呼び出された順番にグループ名と<br />
                経過時間が表示されるので、<br />
                どの呼出機から、いつコールが<br />
                あったか、一目瞭然。
              </p>
              <p style="line-height: 16px; margin-top: 30px;">
                「呼出中」をタッチすれば、<br />
                呼出中の情報を表示。
              </p>
            </div>
            <div style="width: 60%; display: grid" v-else>
              <p style="line-height: 16px;">
                スマホと呼出機を自由にひもづけ。指定した呼出機の情報だけを表示できます。<br />
                ※下記「グループ割当て機能」を参照
              </p>
              <p style="line-height: 16px; margin-top: 15px;">
                呼び出された順番にグループ名と経過時間が表示されるので、
                どの呼出機から、いつコールがあったか、一目瞭然。
              </p>
              <p style="line-height: 16px; margin-top: 10px;">
                「呼出中」をタッチすれば、呼出中の情報を表示。
              </p>
            </div>
          </div>
        </div>
        <div class="feature-content vertical-content">
          <content-header
            title="「履歴」で対応記録を確認"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            「履歴」をタップすれば対応記録を表示。
          </p>
          <p>
            対応した担当者や時間などを表示します。
          </p>
          <div
            style="margin-top: 20px; display: flex; justify-content: space-around;"
          >
            <img
              v-lazy="'/static/products/beyond-ec/feature/feature_03.png'"
              style="position: static; width: 40%; height: 100%;"
              :style="this.$isPC ? '' : 'width: 35%'"
            />
            <div style="width: 50%; display: grid" v-if="this.$isPC">
              <p style="line-height: 16px; margin-top: 110px;">
                対応した担当者名と<br />
                対応時間など<br />
                対応記録を順番に表示。
              </p>
              <p style="line-height: 16px; margin-top: 85px;">
                最後に呼び出されたものが下に配置。
              </p>
              <p style="line-height: 16px; margin-top: 30px;">
                「履歴」をタッチすれば、<br />
                対応済みの情報を表示。
              </p>
            </div>
            <div style="width: 60%; display: grid" v-else>
              <p style="line-height: 16px; margin-top: 25px;">
                対応した担当者名と<br />
                対応時間など<br />
                対応記録を順番に表示。
              </p>
              <p style="line-height: 16px; margin-top: 25px;">
                最後に呼び出された<br />
                ものが下に配置。
              </p>
              <p style="line-height: 16px; margin-top: 5px;">
                「履歴」をタッチすれば、<br />
                対応済みの情報を表示。
              </p>
            </div>
          </div>
        </div>
        <div
          class="feature-content"
          style="width: 40%; margin-top: 0"
          :style="this.$isPC ? '' : 'width: 100%'"
        >
          <content-header
            title="横型レイアウトにも対応"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            画面は縦、横どちらにも対応します。
          </p>
          <p>
            スマホと同様、端末を回転することで自動的に表示が変わります。
          </p>
        </div>
        <div
          style="width: 60%; margin-top: 0; display: flex;justify-content: space-around;"
          :style="this.$isPC ? '' : 'width: 100%'"
        >
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_04.png'"
            style="width: 55%; height: 100%;"
          />
          <div
            style="width: 50%; display: grid; height: fit-content;"
            :style="this.$isPC ? '' : 'font-size: 13px'"
          >
            <p style="line-height: 16px; margin: 0">
              ギアマークを<br />
              クリックすると<br />
              設定メニューが表示
            </p>
            <p
              style="line-height: 16px; margin-top: 35px"
              :style="this.$isPC ? '' : 'margin-top: 5px'"
            >
              最後に呼び出されたものが右に配置。
            </p>
          </div>
        </div>
      </div>

      <div class="feature-title">
        グループ割当て機能
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="呼び出したいスマホを自由に設定"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼出機とレシーバーを自由にひもづけられる「グループ割当機能」を搭載。
          </p>
          <p>
            呼出機<span style="color: rgb(0,95,255); font-weight: bold;">
              ❶（青色）</span
            >はグループ A のレシーバーに、呼出機
            <span style="color: rgb(255,220,92); font-weight: bold;">
              ❷（黄色）</span
            >はグループ B、呼出機
            <span style="color: rgb(255,0,116); font-weight: bold;">
              ❸（ピンク）</span
            >はグループ C…というように、
          </p>
          <p>呼び出したい対象（スマホ）を自由に設定できます。</p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_05.png'"
            style="position: inherit; width: 100%; margin-top: 25px;"
          />
        </div>
        <div class="feature-content">
          <content-header
            title="液晶モニターで、呼出／応対の状況を一目瞭然に把握できます。"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            受信機に液晶モニターを接続すれば、最大 12
            件の呼出情報を表示。現場の状況を一元的にチェックすることができます。
          </p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_06.png'"
            style="position: inherit; width: 100%; margin-top: 25px;"
          />
        </div>
      </div>

      <div class="feature-title">
        受信機＆表示用液晶モニター
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="呼出機の信号を Wi-Fi で表示機（スマホ）へ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼出機からの信号を受信し、Wi-Fi( 無線 LAN) で Android
            スマホに送信します。受信機と液晶モニターを HDMI
            ケーブルで接続すれば呼出の情報を表示できます。
          </p>
          <p>
            受信機に接続されたモニター表示と表示機 (Android スマホ )
            は連動しており、表示機 (Android スマホ )
            での対応をリアルタイムでモニターに反映します。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="最大 12 件の呼び出し情報を表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼び出し情報を 12
            件まで、液晶モニターに表示。最も新しい呼び出し情報は右下に配置されます。
            呼び出しを受けた担当者が対応すれば自動的に画面から消去され、未対応の情報が繰り上がります。
            また特定の呼出機の情報を先頭に表示できる優先表示機能も搭載しています。
          </p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_07.png'"
            style="position: static; width: 100%; margin-top: 25px"
          />
        </div>
        <div class="feature-content">
          <content-header
            title="呼び出し元、呼び出し対象、経過時間が一目で分かる"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            :style="this.$isPC ? 'width: 55%' : 'width: 100%'"
          />
          <div style="width: 50%">
            <p>
              どの場所から誰への呼び出しがあったのか、呼び出してからどれほどの時間が
            </p>
            <p>
              経過したかが表示されます。
            </p>
          </div>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_08.png'"
            style="height: auto;"
            :style="
              this.$isPC ? 'top: -40px; width: 40%;' : 'top: 90px; width: 40%;'
            "
          />
        </div>
      </div>

      <div class="feature-title">
        Windowsパソコン
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="各種設定やログ管理は Windows PC で"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            :style="this.$isPC ? 'width: 55%' : 'width: 100%'"
          />
          <div v-if="this.$isPC">
            <p>Windows PC を接続（無線／有線）し、</p>
            <p>呼出機やレシーバー（スマホ）の登録、各種設定を行います。</p>
            <p>Web ブラウザの設定画面でどなたでも簡単に操作できます。</p>
            <p>また専用アプリを用いれば呼び出し／受信／対応などのログ情報を</p>
            <p>CSV ファイルでダウンロード。</p>
            <p>呼び出しの発生場所や回数、時間帯などを把握できます。</p>
          </div>
          <div v-else>
            <p>
              Windows PCを接続（無線／有線）し、
              呼出機やレシーバー（スマホ）の登録、各種設定を行います。
            </p>
            <p>Web ブラウザの設定画面でどなたでも簡単に操作できます。</p>
            <p>
              また専用アプリを用いれば呼び出し／受信／対応などのログ情報をCSV
              ファイルでダウンロード。
            </p>
            <p>
              呼び出しの発生場所や回数、時間帯などを把握できます。
            </p>
          </div>

          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_09.png'"
            style="height: auto;"
            :style="
              this.$isPC
                ? 'top: -20px; width: 40%;'
                : 'width: 100%; position: static; margin-top: 10px;'
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">導入いただく<br />機器</h2>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre" style="padding-left: 2%">
                電池レス呼出機
              </h3>
              <div class="product-detail">
                <p>電磁誘導式自己発電部内蔵型のコードレスチャイム</p>
              </div>
            </div>
            <div style="padding-top: 10px">
              ボタンを押すだけで自ら発電し、受信機との通信（特定小電力 920MHz
              帯）が可能です。<br />
              登録は受信機の「登録ボタン」でペアリングモードにして行います。<br />
              メッセージの設定は、受信機と Windows PC を有線／無線 LAN
              で接続。PC の Web ブラウザから行います。<br />
              5
              ボタン型は、ボタンごとに呼び出すグループを指定することができます。
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_10.png'"
              style="height: auto"
            />
          </div>

          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">外部入力型送信機</h3>
              <div class="product-detail">
                <p>無人運転機器に接続可能な</p>
                <p>信号入力型送信機</p>
              </div>
            </div>
            <p>
              スイッチやリレーなどの ON
              信号を受けて送信し、無人運転機器等にトラブルが発生した場合に、受信機へ自動送信できます。（2
              入力対応）電源は単三アルカリ乾電池 2 本または AC
              アダプタに対応します。電池と AC アダプタを併用する場合は AC
              アダプタが優先され、AC
              アダプタからの供給がストップすると乾電池で作動します。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_11.png'"
              style="height: auto;"
              :style="this.$isPC ? 'width: 100%' : 'width: 80%; height: auto;'"
            />
          </div>
          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p>呼出機の信号を受信し、その信号をWi-Fiを</p>
                <p>使ってAndroidスマホに送ります。</p>
              </div>
            </div>
            <p>
              液晶モニターを HDMI
              ケーブルで接続すれば呼び出し情報を表示することができます。また稼働後は、有線／無線
              LAN で接続された WindowsPC
              でログ管理や設定変更を行えます。呼出機や消去機、表示機の登録／設定は、受信機と
              WindowsPC を有線／無線 LAN で接続。PC の Web
              ブラウザから行います。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_12.png'"
            />
          </div>

          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>設定不要で、電源にさえ接続していれば、</p>
                <p>使用できます。</p>
              </div>
            </div>
            <p>
              送信機や他の中継機からの電波信号を中継し、遠距離通信を可能にします。
            </p>
            <p style="font-weight: bold">［中継機の設置について］</p>
            <p>
              中継機は呼出機と受信機の中間に設置し、通信距離を延長します。受信機の受信可能距離を上回ったり、障害により電波の受信状況が悪い場所に設置してください。
            </p>
            <div>
              ※呼出機から中継機・受信機への電波到達距離は、ご使用の環境によって異なります。<br />
              ※高温、多湿、ホコリの影響を受けない場所に設置してください。<br />
              ※本製品は防水ではありません。単独での屋外設置は避けてください。
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_13.png'"
              style="width: 80%; height: auto;"
            />
          </div>
          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">電池レス消去機</h3>
              <div class="product-detail">
                <p>呼出機と同じく電池レスの</p>
                <p>消去機です。</p>
              </div>
            </div>
            <p>
              呼出機側での呼出消去、または、Androidスマホでの呼出消去の
              運用が難しい場合等、モニターに表示された呼出情報を上下左右
              のコントロール操作により消去を行います。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_14.png'"
              style="width: 80%; height: auto;"
            />
            <p>消去用赤枠を消去機にてコントロールし消去</p>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">システム<br />構成</h2>
        </div>
      </div>
      <div class="system-config">
        <img v-lazy="'/static/products/beyond-ec/feature/system.png'" />
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          離れた場所からの呼び出しに気づける
        </h3>
      </div>
      <img
        style="width: 100%;max-width: 850px;"
        src="/static/columns/52/img-wantcall_people_easilyinoffice3-1.png"
        alt="ビヨンドイーシー"
      />
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/36">
          <div class="use-scene-block-header">
            工場で「呼びたい人が近くにいない」悩みを解決できる呼び出しベル
          </div>
        </router-link>
        <p>
          工場向けの呼び出しベルを活用すれば、「担当者を呼びたいのに、近くにいない」という問題に対応できるでしょう。製造現場に合った呼び出しベルの選び方を解説します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/44">
          <div class="use-scene-block-header">
            人件費を削減したい飲食店に呼び出しベルの導入がおすすめな理由
          </div>
        </router-link>
        <p>
          この記事では人件費を削減したい飲食店向きに、呼び出しベルの導入がおすすめの理由や呼び出しベルの選び方、オペレーション効率化に向いた機種を紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/42">
          <div class="use-scene-block-header">
            お客様の呼び声に気付けないときにおすすめの呼び出しベルを紹介
          </div>
        </router-link>
        <p>
          この記事では、お客様の呼び出しに気付けない、見逃してしまう、といった状況に悩む飲食店のオーナーに向けて、最適な呼び出しベルの選び方と、おすすめの製品を紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/38">
          <div class="use-scene-block-header">
            生産ラインの効率が悪いときの解決法｜呼び出しベルで生産性アップ！
          </div>
        </router-link>
        <p>
          この記事では工場の生産ラインの効率化や最適化に悩んでいる方に向けて、設備トラブルやチョコ停への効率的な対応に活用できる呼び出しベルの活用方法を解説します。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
            v-bind:appDownloadUrl="appDownloadUrl"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'呼出し状況を離れた場所でも確認できますか？'"
        :answer="
          `通信無料の特定小電力無線(920MHz)と、Wi-Fi(無線LAN)を組み合せた呼び出しシステムですので、専用のレシーバーは不要です。専用アプリをダウンロードすれば、Androidスマホをそのままレシーバーとして利用できます。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'呼び出し内容は番号でのみ表示されるのですか？'"
        :answer="
          `呼出機の名称と番号、呼出対象のグループ名、経過時間が表示されます。又、Androidスマホの履歴画面では、対応した担当者名と対応時間など対応記録が表示されます。`
        "
      />
      <question-and-answer
        :number="3"
        :question="'呼び出し履歴を確認することは出来ますか？'"
        :answer="
          `Windows PC で専用アプリを用いれば、呼び出し／受信／対応などのログ情報をCSV ファイルでダウンロードできます。
           呼び出しの発生場所や回数、時間帯などを把握できます。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/1" target="_blank"
            ><img
              src="/static/columns/24/rest_mv.png"
              alt="飲食店の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/1" target="_blank"
              >飲食店の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/1" target="_blank"
            ><img
              src="/static/columns/1/img_hospital_waiting_time1.jpg"
              alt="【病院関係者向け】待ち時間対策の重要性や効果的な方法を解説！"
          /></a>

          <h3>
            <a href="/column/1" target="_blank"
              >【病院関係者向け】待ち時間対策の重要性や効果的な方法を解説！</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/2" target="_blank"
            ><img
              src="/static/columns/2/img_nurse_call_usage1.jpg"
              alt="ナースコールの使い方を4つのタイプ別に解説！活用のポイントも"
          /></a>

          <h3>
            <a href="/column/2" target="_blank"
              >ナースコールの使い方を4つのタイプ別に解説！活用のポイントも</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data() {
    return {
      productName: 'beyond-ec',
      useType: 2,
      items: [
        {
          name: '受信機Wi-Fiモデル',
          imagePath: '/static/products/beyond-ec/items/item_01.png',
          spec: {
            品番: `BEC-100`,
            電源入力: `AC100-240V`,
            電源出力: `DC6V`,
            外観: `ABS 樹脂（グレーメタリック）`,
            出力機能: `有線 LAN・無線 LAN、HDMI 出力端子、
            USB ポート`,
            受信周波数: `928.85MHz`,
            受信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `138（W）×48（D）×120（H）mm
            （アンテナを含めた高さ 210 ㎜ )`,
            重量: `230g`,
            保証: `1 年`,
          },
          priceName: `受信機Wi-Fiモデル（BEC-100)`,
          listPrice: 182000,
          regularPrice: 182000,
          openPrice: 182000,
        },
        {
          name: '中継機',
          imagePath: '/static/products/beyond-ec/items/item_02.png',
          spec: {
            品番: `BEC-500`,
            電源入力: `AC100-240V`,
            電源出力: `DC6V`,
            外観: `ABS 樹脂（ブラック）`,
            受信周波数: `928.85MHz`,
            送信周波数: `928.85MHz 1mW`,
            受信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `100（W）×22（D）×60（H）mm
            （アンテナを含めた高さ 210 ㎜ )`,
            重量: `75g`,
            保証: `1 年`,
          },
          priceName: `中継機（BEC-500)`,
          listPrice: 30000,
          regularPrice: 21000,
          openPrice: 30000,
        },
        {
          name: '電池レス呼出機 角型 1ボタン',
          imagePath: '/static/products/beyond-ec/items/item_03.png',
          spec: {
            品番: `角アイボリー（BEC-211）
            角ブラック（BEC-212）`,
            電源: `電磁誘導式自己発電`,
            外観: `ABS 樹脂`,
            送信周波数: `928.85MHz 1mW`,
            送信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `68（W）×22（D）×68（H）mm`,
            重量: `80g`,
            保証: `1 年`,
          },
          priceName: `電池レス呼出機 角型 1 ボタン
          角アイボリー (BEC-211）
          角ブラック (BEC-212）`,
          listPrice: 15000,
          regularPrice: 10500,
          openPrice: 15000,
        },
        {
          name: '電池レス呼出機 丸型 1ボタン',
          imagePath: '/static/products/beyond-ec/items/item_04.png',
          spec: {
            品番: `丸ホワイト（BEC-221）
            丸ブラック（BEC-222）`,
            電源: `電磁誘導式自己発電`,
            外観: `ABS 樹脂`,
            送信周波数: `928.85MHz 1mW`,
            送信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `74（W）×30（D）×74（H）mm`,
            重量: `65g`,
            保証: `1 年`,
          },
          priceName: `電池レス呼出機 丸型 1 ボタン
          丸ホワイト (BEC-221）
          丸ブラック (BEC-222）`,
          listPrice: 15000,
          regularPrice: 10500,
          openPrice: 15000,
        },
        {
          name: '電池レス呼出機 ５ボタン',
          imagePath: '/static/products/beyond-ec/items/item_05.png',
          spec: {
            品番: `BEC-251`,
            電源: `電磁誘導式自己発電`,
            外観: `ABS 樹脂`,
            送信周波数: `928.85MHz 1mW`,
            送信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `76（W）×28（D）×76（H）mm`,
            重量: `75g`,
            保証: `1 年`,
          },
          priceName: `電池レス呼出機
          5 ボタン（BEC-251）`,
          listPrice: 17000,
          regularPrice: 12000,
          openPrice: 17000,
        },
        {
          name: '電池レス消去機',
          imagePath: '/static/products/beyond-ec/items/item_06.png',
          spec: {
            品番: `BEC-400`,
            電源: `電磁誘導式自己発電`,
            外観: `ABS 樹脂`,
            送信周波数: `928.85MHz 1mW`,
            送信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `-10℃～ 40℃`,
            サイズ: `76（W）×28（D）×76（H）mm`,
            重量: `75g`,
            保証: `1 年`,
          },
          priceName: `電池レス消去機（BEC-400)`,
          listPrice: 18500,
          regularPrice: 13000,
          openPrice: 18500,
        },
        {
          name: '外部入力送信機 ACアダプター付き',
          imagePath: '/static/products/beyond-ec/items/item_07.png',
          spec: {
            品番: `BEC-231`,
            電源: `単三アルカリ電池 ×2 本 /DC3V 専用アダプター`,
            外観: `ABS 樹脂`,
            送信周波数: `928.85MHz 1mW`,
            送信可能距離: `約 80m（見通し距離）`,
            使用可能周囲温度: `0℃～ 40℃`,
            サイズ: `75（W）×36.9（D）×116（H）mm
            ※ホルダー装着時は、
            75.42（W）×42.1（D）×116.42（H）mm）`,
            重量: `165g（単三アルカリ電池 ×2 本含む）
            ※ホルダー装着時は 190g
            （単三アルカリ電池 ×2 本含む）`,
            保証: `1 年`,
          },
          priceName: `外部入力送信機 ACアダプター付き（BEC-231)`,
          listPrice: 18200,
          regularPrice: 18200,
          openPrice: 18200,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'ビヨンドイーシー',
          imagePath: '/static/products/beyond-ec/catalogues/catalogue_01.png',
          downloadUri: '/static/products/beyond-ec/catalogues/catalogue_01.pdf',
          pageCount: 8,
          fileType: 'PDF',
          fileSize: '約 2.4MB',
        },
        {
          id: 2,
          name: 'ビヨンドイーシー 取り扱い説明書',
          imagePath: '/static/products/beyond-ec/catalogues/catalogue_02.png',
          downloadUri: '/static/products/beyond-ec/catalogues/catalogue_02.pdf',
          pageCount: 24,
          fileType: 'PDF',
          fileSize: '約 3.8MB',
        },
      ],
      appDownloadUrl: 'https://echo5555.co.jp/products/beyond_ec_appli.php',
    }
  },
}
</script>

<style scoped>
.feature-section .header h3 {
  color: rgb(16, 106, 203);
  font-size: 1.5em;
}

.feature-section .header h2 {
  color: rgb(16, 106, 203);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;

  display: inline-block;

  margin: 30px 0 10px;
  padding: 0 25px;

  color: white;
  border-radius: 20px;
  background-color: rgb(16, 106, 203);
}

.sp-product .feature-content {
  margin: 20px 0;
}

.feature-section .main-function {
  background-color: rgb(242, 246, 250);
}

.feature-section .main-function .body {
  width: 90%;
  max-width: 1100px;
}

.feature-section .main-function .body .product-block {
  width: 100%;
  margin: 20px 0;
}

.feature-section .main-function .body .product-block .content-header {
  font-size: 18px;

  margin-bottom: 20px;
}

.feature-section .main-function .body .functions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sp-product .feature-section .main-function .body .functions {
  flex-direction: column;
}

.feature-section .main-function .body .functions .function {
  width: 45%;
  margin-bottom: 10px;

  border: none;
}

.sp-product .feature-section .main-function .body .functions .function {
  width: 100%;
}

.function .function-title {
  padding-bottom: 5px;

  border-bottom: 1px solid rgb(178, 194, 201);
}

.feature-section .main-function .body .vertical-functions {
  display: inline-block;

  width: 80%;
}

.feature-section .main-function .body .vertical-functions .function {
  margin-bottom: 10px;

  border: none;
}

.feature-image {
  display: block;

  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.feature-top .feature-contents .feature-content.vertical-content {
  position: static;

  width: 45%;
  margin: 0 0 50px;
}

.sp-product .feature-top .feature-contents .feature-content.vertical-content {
  width: 100%;
  max-width: 400px;
  margin-bottom: 10px;
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-genre {
  width: 96%;
  margin-bottom: 10px;
  padding: 3px 0 3px 4%;
  text-align: left;
  border-radius: 20px;
}

.feature-section .system-config {
  background: linear-gradient(rgb(228, 236, 243), white);
}

.feature-section .system-config img {
  width: 90%;
  max-width: 1100px;
  padding: 120px 0 60px;
}

.worries-column .use-scene-block .use-scene-block-header {
  border-left: 4px solid rgb(16, 106, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/BeyondEc.vue